
export function debounce(cb, ms, self) {
  let lastCall = new Date();
  let handle;

  return function() {
    let time = new Date();
    let elapsed = time - lastCall;
    clearTimeout(handle);
    if (elapsed > ms) {
      cb.apply(self, arguments)
    } else {
      lastCall = time;
      const args = arguments;
      handle = setTimeout(function() {
        cb.apply(self, args);
      }, ms)
    }
  }
}

export function formatNumber(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function generateCSV(mainSubreddit, relatedSubreddits) {
  const csvRows = [];
  
  // Add main subreddit as first row
  csvRows.push(escapeCSVValue(mainSubreddit));
  
  // Add related subreddits as subsequent rows
  relatedSubreddits.forEach(subreddit => {
    csvRows.push(escapeCSVValue(subreddit));
  });
  
  return csvRows.join('\n');
}

export function escapeCSVValue(value) {
  // Handle commas, quotes, and newlines in CSV values
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return '"' + value.replace(/"/g, '""') + '"';
  }
  return value;
}

export function downloadCSV(csvContent, filename) {
  // Create a UTF-8 BOM for proper encoding
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
  
  // Create download link
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  // Trigger download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Clean up
  URL.revokeObjectURL(url);
}

export function generateJSON(mainSubreddit, relatedSubreddits) {
  // Sort and deduplicate related subreddits for stability
  const uniqueRelated = [...new Set(relatedSubreddits)].sort();
  
  return {
    mainSubreddit,
    related: uniqueRelated
  };
}

export function downloadJSON(jsonData, filename) {
  const jsonString = JSON.stringify(jsonData, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json;charset=utf-8;' });
  
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}

export function respondWithJSON(jsonData, statusCode = 200) {
  const jsonString = JSON.stringify(jsonData, null, 2);
  
  // Check if this is an automation request (raw parameter or specific user agent patterns)
  const urlParams = new URLSearchParams(window.location.search);
  const isRawRequest = urlParams.get('raw') === 'true';
  const userAgent = navigator.userAgent.toLowerCase();
  const isAutomationClient = isRawRequest || 
    userAgent.includes('curl') || 
    userAgent.includes('wget') || 
    userAgent.includes('python') ||
    userAgent.includes('node') ||
    userAgent.includes('bot') ||
    userAgent.includes('automation');
  
  if (isAutomationClient) {
    // For automation clients, replace entire page with minimal JSON output
    document.open();
    document.write(`<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta http-equiv="Content-Type" content="application/json; charset=utf-8">
  <title>JSON Response</title>
</head>
<body>
  <pre id="json-data">${jsonString}</pre>
  <script>
    // Set content type for automation detection
    if (window.location.search.includes('raw=true')) {
      document.body.style.margin = '0';
      document.body.style.padding = '0';
      document.body.style.fontFamily = 'monospace';
      document.querySelector('pre').style.margin = '0';
      document.querySelector('pre').style.padding = '10px';
      document.querySelector('pre').style.backgroundColor = 'white';
    }
  </script>
</body>
</html>`);
    document.close();
    return jsonData;
  }
  
  // For browser requests, use the existing styled interface
  const app = document.getElementById('app');
  if (app) {
    app.style.display = 'none';
  }
  
  const jsonContainer = document.createElement('div');
  jsonContainer.id = 'json-response';
  jsonContainer.innerHTML = `
    <style>
      #json-response {
        font-family: monospace;
        margin: 20px;
        padding: 20px;
        background: #f9f9f9;
        border-radius: 8px;
        max-width: 800px;
      }
      #json-response h3 {
        margin-top: 0;
        color: #333;
      }
      #json-response pre {
        background: #fff;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 4px;
        overflow: auto;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
      #json-response .meta {
        font-size: 12px;
        color: #666;
        margin-bottom: 10px;
      }
      .raw-link {
        margin-top: 10px;
        font-size: 12px;
      }
      .raw-link a {
        color: #007bff;
        text-decoration: none;
      }
    </style>
    <h3>JSON Export Response</h3>
    <div class="meta">Content-Type: application/json; charset=utf-8</div>
    <div class="meta">Status: ${statusCode}</div>
    <div class="raw-link">
      <strong>For automation/API access:</strong> 
      <a href="${window.location.href}&raw=true" target="_blank">Raw JSON URL</a>
    </div>
    <pre>${jsonString}</pre>
  `;
  
  document.body.appendChild(jsonContainer);
  document.title = 'JSON Export - Map of Reddit';
  
  return jsonData;
}

export function createErrorResponse(code, message) {
  return {
    error: {
      code,
      message
    }
  };
}